// Module
var code = "<a ng-if=\"billingItemGroup.length > 1\" class=\"pointer cd-tooltip\" layout=\"row\" layout-align=\"center center\" tooltips tooltip-side=\"right\" tooltip-template-url=\"views/directive/cd-billing-item-tier-tooltip.html\"> <span>i</span> </a> ";
// Exports
var _module_exports = code;;
var path = 'views/directive/cd-billing-item-tier.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;